import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoSquareRounded from '@assets/img/icons/info-rounded-square.svg?react';

import Close from '@/assets/img/icons/close-v3.svg?react';
import { H1, StringSmall } from '@/components/Typography/Typography';
import RadialCircleGradient from '@/components/ui/Gradient/RadialCircleGradient';
import { useAppSelector } from '@/redux/store';

import { arenaOffersInfo } from '../config';

import ProfitDropDefaultTab from './tabs/ProfitDropDefaultTab';
import ProfitDropInfoTab from './tabs/ProfitDropInfoTab';

import css from '../style.module.scss';

const ProfitDropCard: React.FC = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<'default' | 'info'>('default');
  const activeCard = useAppSelector(
    (state) => state.shop.activeProfitDropOffer,
  );

  if (!activeCard) return null;
  const info = arenaOffersInfo[activeCard.name];

  return (
    <div className={css.profitDrop}>
      <RadialCircleGradient
        className="absolute !w-[50%] !h-auto aspect-[175/103]  translate-x-[42%] translate-y-[-52%] top-0 right-0"
        type="purple"
      />
      <RadialCircleGradient
        className="absolute !w-[50%] !h-auto aspect-square opacity-50 translate-x-[-55%] translate-y-[55%] bottom-0 left-0"
        type="purple"
      />
      <RadialCircleGradient
        className="absolute !w-[50%] !h-auto aspect-square opacity-50 translate-x-[-50%] translate-y-[-50%] top-0 left-0"
        type="purple"
      />
      <div className="flex flex-col">
        <H1 className="!text-[18px]">{t(info.title)}</H1>
        <StringSmall className="!text-[10px] leading-none !text-[#E7D7FF]">
          {t(info.describe)}
        </StringSmall>
      </div>
      {tab === 'default' && <ProfitDropDefaultTab activeCard={activeCard} />}
      {tab === 'info' && <ProfitDropInfoTab activeCard={activeCard} />}
      <button
        onClick={() => setTab((p) => (p === 'default' ? 'info' : 'default'))}
        className="absolute top-2 right-2"
      >
        {tab === 'default' ? (
          <InfoSquareRounded className="size-8" />
        ) : (
          <Close className="size-8" />
        )}
      </button>
    </div>
  );
};

export default ProfitDropCard;
